// extracted by mini-css-extract-plugin
module.exports = {"moduleCalendar":"Calendar_moduleCalendar__19GKK","formGroup":"Calendar_formGroup__3LnDc form-group","label":"Calendar_label__3nrkI h6 d-block text-center"};